import { FC, useRef, useContext, useEffect } from 'react'
import cn from 'classnames'
import styles from 'components/features/pfm/ActionMenu/ActionMenu.styl'
import { OuterEventTrackerContext } from 'components/utils/OuterEventTracker'

export type ActionMenuProps = {
  onHide: () => void
  className?: string
}

export const ActionMenu: FC<ActionMenuProps> = (props) => {
  const { children, className, onHide } = props

  const nodeRef = useRef<HTMLDivElement>(null)
  const outerEventTracker = useContext(OuterEventTrackerContext)

  useEffect(() => {
    if (!nodeRef.current) {
      return
    }

    outerEventTracker.addOuterEventListener('click tap', onHide, nodeRef.current)

    return () => outerEventTracker.removeOuterEventListener('click tap', onHide)
  }, [onHide, outerEventTracker])

  return (
    <div
      className={ cn(styles.container, className) }
      ref={ nodeRef }
    >
      { children }
    </div>
  )
}
